import React, { useState, useEffect, useRef } from "react";
import Icon from "@mdi/react";
import { mdiPlusCircle } from "@mdi/js";
import SectionOption from "../Section/option";

type Option = {
  value: string;
  label: string;
};

interface MagicSelectFormProps {
  options: Option[];
  selected: Option[];
  setSelected: React.Dispatch<React.SetStateAction<Option[]>>;
  placeholder?: string;
  onAdd?: () => void;
  addTooltip?: string;
}

export const MagicSelectForm: React.FC<MagicSelectFormProps> = ({
  options,
  selected,
  setSelected,
  placeholder = "Selecione...",
  onAdd,
  addTooltip
}) => {
  const [search, setSearch] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef<HTMLDivElement | null>(null);

  // Fecha ao clicar fora
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const filteredOptions = options.filter(
    (opt) =>
      opt.label.toLowerCase().includes(search.toLowerCase()) &&
      !selected.some((sel) => sel.value === opt.value)
  );

  const toggleSelect = (option: Option) => {
    if (selected.some((sel) => sel.value === option.value)) {
      setSelected(selected.filter((sel) => sel.value !== option.value));
    } else {
      setSelected([...selected, option]);
    }
  };

  const removeItem = (value: string) => {
    setSelected(selected.filter((sel) => sel.value !== value));
  };

  return (
    <div className="w-100" ref={wrapperRef}>
      {/* Caixa do Select + botão de ação */}
      <div className="position-relative mb-2">
        <div className="d-flex align-items-end gap-2">
          <div className="flex-grow-1">
            <div
              onClick={() => setIsOpen(!isOpen)}
              className="form-control d-flex justify-content-between align-items-center"
              style={{ cursor: "pointer", minHeight: 42 }}
            >
              <span className={selected.length > 0 ? "text-body" : "text-muted"}>
                {selected.length > 0
                  ? `${selected.length} selecionado(s)`
                  : placeholder}
              </span>
              <span className="text-muted">▾</span>
            </div>

            {isOpen && (
              <div
                className="position-absolute mt-1 w-100 border rounded bg-white shadow-sm"
                style={{ zIndex: 1000 }}
              >
                <input
                  type="text"
                  placeholder="Pesquisar..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  className="form-control border-0 border-bottom rounded-0"
                  style={{ fontSize: "0.85rem" }}
                />

                <ul
                  className="list-unstyled mb-0"
                  style={{ maxHeight: "220px", overflowY: "auto" }}
                >
                  {filteredOptions.length > 0 ? (
                    filteredOptions.map((opt) => (
                      <li
                        key={opt.value}
                        onClick={() => toggleSelect(opt)}
                        className="px-3 py-2 list-group-item-action"
                        style={{ cursor: "pointer", fontSize: "0.9rem" }}
                      >
                        {opt.label}
                      </li>
                    ))
                  ) : (
                    <li className="px-3 py-2 text-muted" style={{ fontSize: "0.85rem" }}>
                      Nenhum resultado
                    </li>
                  )}
                </ul>
              </div>
            )}
          </div>

          {onAdd && (
           

                                <SectionOption
                                icon={mdiPlusCircle}
                                tooltip="Atualizar"
                                onClick={() => onAdd()}
                            />
          )}
        </div>
      </div>

      {/* Lista de Selecionados */}
      {selected.length > 0 && (
        <div className="mt-2">
          <small className="d-block mb-2 text-muted">
            Selecionados:
          </small>
          <div className="d-flex flex-wrap gap-2">
            {selected.map((sel) => (
              <span
                key={sel.value}
                className="badge bg-primary d-flex align-items-center px-3 py-2"
                style={{ borderRadius: "20px", fontSize: "0.85rem" }}
              >
                {sel.label}
                <button
                  onClick={() => removeItem(sel.value)}
                  type="button"
                  className="btn-close btn-close-white ms-2"
                  aria-label="Remover"
                  style={{ fontSize: "0.6rem" }}
                />
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
